import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const EditHoldingDataPage = withSuspense(lazy(() => import('./edit-holding-data')));
export default EditHoldingDataPage;
